export default '/build/56f59e34.svg'